import {TutorialBase} from "./tutorial-base";

export class BaseForm extends TutorialBase {
  public id: string;
  public active: boolean = false;
  public formSchema: any = {components: []};
  public name: string;
  public shortname: string;
  public jsonDeterminants: string;
}
